import { FC, useMemo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { PopularRequest } from 'modules/marketing-pages/service';

import ProCard from 'modules/marketing-pages/components/ListPros/ProCard';
import { logEvent } from 'utils/analytics';
import styles from './VerticalPopularRequestItem.module.scss';
import { FlexibleRequestDetailsTable } from '@z-components/molecules/RequestDetailsTable/FlexibleRequestDetailsTable';
import { isMobile } from 'utils/layout';

interface Props {
  isReviewsQAEnabled: boolean;
  popularRequest: PopularRequest;
}

const RequestDetails: FC<Props> = ({
  popularRequest: {
    request: { fields, jobTypeId },
    sampleApplyInfo,
  },
  isReviewsQAEnabled,
}) => {
  const {
    i18n: { language },
  } = useTranslation('marketingPages');

  const [isMobileDevice, setMobileDevice] = useState(false);

  useEffect(() => {
    setMobileDevice(isMobile(window.screen.width));
  }, []);

  const requestFieldsWithValues = useMemo(
    () =>
      fields.filter(({ value }) => {
        if (typeof value === 'string' || Array.isArray(value)) {
          return value.length > 0;
        } else if (typeof value === 'object') {
          return Object.keys(value).length > 0;
        }
        return false;
      }),
    [fields]
  );
  const handleGoogleAnalytics = useCallback(
    (eventType: string) => {
      logEvent(`LandingPagePro:${jobTypeId}`, `${eventType}`);
    },
    [jobTypeId]
  );

  const { proProfile } = sampleApplyInfo;

  return (
    <div className={styles.container}>
      <FlexibleRequestDetailsTable
        defaultRenderLine={isMobileDevice ? 1 : 2}
        language={language as 'en' | 'ja'}
        requestFields={requestFieldsWithValues}
      />
      <div className={styles['pro-card-container']}>
        <ProCard
          onGoogleAnalytics={handleGoogleAnalytics}
          pro={proProfile}
          jobTypeId={jobTypeId}
          applyMessage={sampleApplyInfo.coverLetter}
          isReviewsQAEnabled={isReviewsQAEnabled}
        />
      </div>
    </div>
  );
};

export default RequestDetails;
